import { getItemWeight } from "@sellar-io/common";
import { useOrder } from "../../hooks/api/v2/order/useOrder";
import dayjs from "dayjs";

export const useCollectionOrderData = (
  orderId?: number,
): {
  totalWeight: number;
  numberOfPackages: number;
  overWeight: boolean;
  dispatchDate: Date;
} => {
  const orderQuery = useOrder(orderId ?? 0);

  const today = dayjs().toDate();

  const initialData = {
    totalWeight: 0,
    numberOfPackages: 0,
    overWeight: false,
    dispatchDate: today,
  };

  const { data } = orderQuery;

  if (!orderId || !data) return initialData;

  return data.OrderItems.reduce((accumulator, item) => {
    const itemWeight = getItemWeight(item.Product);

    return {
      totalWeight: (accumulator.totalWeight += itemWeight * item.quantity),
      numberOfPackages: (accumulator.numberOfPackages += item.quantity),
      overWeight: itemWeight > 32,
      dispatchDate: data.dispatchPlannedAt ?? today,
    };
  }, initialData);
};
